<template>
  <div class="col-md-12">
    <div class="ln_solid"></div>
    <br />
    <form role="form" @submit.prevent="searchData()">
      <div class="row">
        <div class="col-2">
          <select id="region" class="form-control" v-model="pagingInfo.region">
            <option value="">Select Region</option>
            <option value="D010">NCR</option>
            <option value="RECSC20210001">CAR</option>
            <option value="D011">RO1</option>
            <option value="D012">RO2</option>
            <option value="D013">RO3</option>
            <option value="D014">RO4</option>
            <option value="RECSC20210002">RO4B</option>
            <option value="D015">RO5</option>
            <option value="D016">RO6</option>
            <option value="D017">RO7</option>
            <option value="D018">RO8</option>
            <option value="D019">RO9</option>
            <option value="D020">RO10</option>
            <option value="D021">RO11</option>
            <option value="D022">RO12</option>
            <option value="RECSC20120006">RO13</option>
            <option value="RECSC20230002">BARMM</option>
            <option value="D003">D2</option>
            <option value="D002">D3</option>
            <option value="RECSC20090004">D4</option>
            <option value="RECSC20070004">D5</option>
            <option value="RECSC20190001">D6</option>
          </select>
        </div>
        <div class="col-2">
          <input type="text" class="form-control" v-model="pagingInfo.search" placeholder="File Name" />
        </div>
        <div class="col-2">
          <input type="date" class="form-control" v-model="pagingInfo.datestart" placeholder="Date Start" />
        </div>
        <div class="col-2">
          <input type="date" class="form-control" v-model="pagingInfo.dateend" placeholder="Date End" />
        </div>
        <div class="col-2">
          <button type="submit" class="btn btn-info">
            <strong>Search</strong>
          </button>
        </div>
      </div>
    </form>
    <br>
    <div class="box">
      <div class="box-header"></div>
      <div class="box-body table-responsive no-padding">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Date</th>
              <th>Uploaded By</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sois" :key="item.id">
              <td>{{ item.filE_NAME }}</td>
              <td>{{ item.datE_OF_ACTIVITY | formatDate }}</td>
              <td>{{ item.username }}</td>
              <td>
                <TheDropDownButton>
                  <TheIconButton @click.native="
                    downloadsoi(item.objectid, item.filE_NAME, item.filE_TYPE)
                    " icon="fa fa-download" title="Downloadable Profile"></TheIconButton>
                  <TheIconButton @click.native="
                    viewLogs(item.id)
                    " icon="fa fa-cogs" title="View Download Logs"></TheIconButton>
                  <!-- put a delete button for crad users -->
                </TheDropDownButton>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-show="totalitems == 0" class="alert alert-warning">
          <p>Found no result try again</p>
        </div>
      </div>
      <div class="box-footer clearfix">
        <b-pagination v-model="pagingInfo.page" v-on:input="fetchData()" :total-rows="totalitems"
          :per-page="pagingInfo.itemsPerPage" first-text="First" prev-text="Prev" next-text="Next"
          last-text="Last"></b-pagination>
      </div>
    </div>
    <b-modal id="loglistbyid" size="xl" title="Download Logs" scrollable hide-footer>
      <LogViewer v-bind:id="logid" v-bind:url="urlLog" />
    </b-modal>
  </div>
</template>
<script>
import {
  authHeader,
  responseCheck,
  RecordURL,
  notifyHelper,
  downloadblob,
  EncodeURL
} from "../helper";
import TheIconButton from "./buttons/iconButton";
import instance from "../helper/http";
import LogViewer from "./master/downloadLogs.vue"

export default {
  data() {
    return {
      pagingInfo: {
        page: 1,
        reverse: false,
        region: "",
        datestart: "",
        dateend: "",
        itemsPerPage: 20,
        search: ""
      },
      totalitems: null,
      sois: [],
      logid: "",
      urlLog : "getprofiledownloadlogsbyid"
    };
  },
  components: {
    TheIconButton,
    LogViewer
  },
  methods: {
    searchData() {
      this.pagingInfo.page = 1;
      this.fetchData();
    },
    fetchData() {
      instance
        .get(RecordURL + "soiList", {
          headers: authHeader(),
          params: this.pagingInfo,
        })
        .then((response) => {
          this.sois = response.data.data;
          this.totalitems = response.data.count;
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        });
    },
    downloadsoi: function (folder, file, type) {
      instance
        .get(RecordURL + "downloadsoi?folder=" + folder + "&filename=" + file, {
          headers: authHeader(),
          responseType: "blob",
        })
        .then((response) => {
          downloadblob(file, response.data, type);
          [];
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        });
    },
    deleteSOI: function (iD, fileName, entryId) {
      if (confirm("are you sure you want to delete?")) {
        instance
          .get(
            EncodeURL +
            "deleteSOI?iD=" +
            iD +
            "&fileName=" +
            fileName +
            "&EntryId=" +
            entryId,
            {
              headers: authHeader(),
            }
          )
          .then((response) => {
            if (response.data.error) {
              notifyHelper("error", response.data.message);
            } else {
              notifyHelper("success", response.data.message);
            }
          })
          .catch(function (error) {
            responseCheck(error.response.status);
          });
      }

    },
    viewLogs(id) {
      this.logid = id;
      this.$bvModal.show("loglistbyid");
    }
  },
};
</script>

